module.exports = __webpack_public_path__ + "static/media/screenshot-8.da1acc2d.png";